import type { Dayjs } from 'dayjs';

export interface CalendarDay {
  date: Dayjs;
  isCurrentMonth: boolean;
}

const CALENDAR_GRID_WEEKS = 6;
const DAYS_PER_WEEK = 7;

export const buildCalendarDays = (viewDate: Dayjs): CalendarDay[] => {
  const startOfMonth = viewDate.startOf('month');
  const gridStart = startOfMonth.subtract(startOfMonth.day(), 'day');

  return Array.from(
    { length: CALENDAR_GRID_WEEKS * DAYS_PER_WEEK },
    (_, index) => {
      const date = gridStart.add(index, 'day');

      return { date, isCurrentMonth: date.month() === viewDate.month() };
    }
  );
};
